import { useState } from 'react'
import emailjs from 'emailjs-com'

const initialState = {
  name: '',
  email: '',
  message: '',
}
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState)

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setState((prevState) => ({ ...prevState, [name]: value }))
  // }
  const clearState = () => setState({ ...initialState })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(name, email, message)
    emailjs
      .sendForm(
        'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID'
      )
      .then(
        (result) => {
          console.log(result.text)
          clearState()
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Contactanos</h2>
                <p>
                     <i className='fa fa-calendar'></i> - Consultá disponibilidad.
                </p>
                <p>
                   <i className='fa fa-check-circle'></i> - Hacé tu reserva.
                </p>
                <p>
                  ¿ Deseas mayor Información?
                </p>
                <div >
                  <button type='submit' className='btn btn-custom btn-lg'>
                    <a width='80' h
                      href="https://wa.me/5492995850031?text=¡Hola!%20¿Tienes disponibilidad?%20Saludos!%20con%20vos :)"
                    > <strong className='fa fa-whatsapp'></strong> Envianos un WhattsApp</a>
                  </button>
                </div>
              </div>
              <form name='sentMessage' validate onSubmit={handleSubmit}>
                {/* <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p> */}
                {/* </div> */}
                <div id='success'></div>

              </form>
            </div>
          </div>


          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-map-marker'></i> Dirección
                </span>
                {props.data ? props.data.address : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Telefono
                </span>{' '}
                {props.data ? props.data.phone : 'loading'}
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                {props.data ? props.data.email : 'loading'}
              </p>

            </div>
          </div>
          <div className='col-md-12'>
            <div >
              <iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.1344293856064!2d-68.2936483!3d-38.6227884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x960ba90075aaa6d9%3A0xeee3cdb56c4e196b!2sAlojamientos%20Robert&#39;s%20Services!5e0!3m2!1ses!2sar!4v1752027784551!5m2!1ses!2sar"><a href="https://www.maps.ie/distance-area-calculator.html">
                  Mensura Mapa </a>
              </iframe>
            </div>

            <div className='row'>
              <div className='social'>
                {/* */ <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-instagram'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : '/'}>
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2025 Robert Services{' '}
            <a href='' rel='nofollow'>
              todos los derechos reservados
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
